import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import {  useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
// import Resizer from "react-image-file-resizer";
import { useSelector } from "react-redux";
import logo from "../../../logo.svg";
import {
  useAddSettingsMutation,
  useSettingsQuery,
} from "../../../services/settingsApi";
import { JwtReValidate, signInUser } from "../../Utility/Auth";
import { notify } from "../../Utility/Notify";
//icons
import { IoSave } from "react-icons/io5";

const BannerSettings = () => {
  const user = signInUser();
  const { aamarId, ecommerceSettings } = user;
  const { bannerSettings } = ecommerceSettings || {};
  const lang = useSelector((state) => state.languageReducer);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);

  console.log("USER::>>", user);
  console.log("bannerSettings", bannerSettings);
  
  const [addSettings, { isLoading }] = useAddSettingsMutation();
  const [isEcommerceToggled, setIsEcommerceToggled] = useState(false);
  const [selectedImage, setSelectedImage] = useState("image1");

  // Get current banner from array or create default
  const getCurrentBanner = () => {
    if (bannerSettings?.banners && bannerSettings.banners[currentBannerIndex]) {
      return bannerSettings.banners[currentBannerIndex];
    }
    return {
      title: "",
      subtitle: "",
      buttonText: "Shop Now",
      buttonLink: "/products",
      image: "",
      isActive: true
    };
  };

  const currentBanner = getCurrentBanner();

  const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm({
    defaultValues: {
      bannerSettings: {
        title: currentBanner.title || "",
        subtitle: currentBanner.subtitle || "",
        buttonText: currentBanner.buttonText || "Shop Now",
        buttonLink: currentBanner.buttonLink || "/products",
        image: currentBanner.image || "",
        isActive: currentBanner.isActive !== false
      }
    }
  });

  // Handle image upload preview
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setBannerPreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle form submission
  const onSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      setErrorMessage(null);
      
      console.log("Form data:", data);
      
      // Create a new banner object
      const newBanner = {
        title: data.bannerSettings.title,
        subtitle: data.bannerSettings.subtitle,
        buttonText: data.bannerSettings.buttonText,
        buttonLink: data.bannerSettings.buttonLink,
        image: bannerPreview || data.bannerSettings.image,
        isActive: data.bannerSettings.isActive !== false
      };
      
      // Create or update banners array
      let updatedBanners = [];
      
      if (bannerSettings?.banners && bannerSettings.banners.length > 0) {
        // Update existing banner array
        updatedBanners = [...bannerSettings.banners];
        
        if (currentBannerIndex < updatedBanners.length) {
          // Update existing banner
          updatedBanners[currentBannerIndex] = newBanner;
        } else {
          // Add new banner
          updatedBanners.push(newBanner);
        }
      } else {
        // Create new banner array with single banner
        updatedBanners = [newBanner];
      }
      
      // Create payload that matches the backend model structure exactly
      const payload = {
        aamarId: aamarId,
        bannerSettings: {
          banners: updatedBanners
        }
      };
      
      console.log("Sending payload to API:", payload);
      
      const response = await addSettings(payload).unwrap();
      // console.log("API response:", response);
      
      await JwtReValidate();
      notify("Banner settings saved successfully!", "success");
      
      // Force reload the page to get updated user data after JWT revalidation
      window.location.reload();
    } catch (err) {

      
      setErrorMessage('Failed to save banner settings');
      notify('Failed to save banner settings', "error");
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div className="">
      <div>
        {/* Banner Section */}
        <form
          style={{ marginTop: "80px" }}
          onSubmit={handleSubmit((data) =>
            onSubmit(data, "Contact Settings added successfully!")
          )}
        >
          <div className="mb-4">
            <h5 className="mb-3 d-flex align-content-center gap-2 mt-5">
              <Icons.UserOutline />
              Banner Settings
            </h5>
            <hr />
            <div className="row mb-2">
              <label className="col-sm-4 col-form-label">Banner Photo</label>
              <div className="col-sm-12">
                <input
                  type="email"
                  className="form-control"
                  {...register("bannerPhoto")}
                  placeholder="Banner Photo"
                />
              </div>
            </div>

            <div className="d-flex justify-content-between mb-4 mt-3">
              <span className="d-flex align-content-center gap-2">
                Banner Style
              </span>
              <div className="image-selection d-flex gap-3">
                {[
                  { key: "image1", label: "Full-Screen" },
                  { key: "image2", label: "Half-Screen" },
                  { key: "image3", label: "Split-Screen" },
                ].map((item, index) => (
                  <div
                    key={index}
                    onClick={() =>
                      !isEcommerceToggled && setSelectedImage(item.key)
                    }
                    className={`theme-option text-center ${
                      selectedImage === item.key ? "selected" : ""
                    }`}
                    style={{
                      border:
                        selectedImage === item.key
                          ? "1px solid #F2652D"
                          : "1px solid #ccc",
                      padding: "5px",
                      cursor: isEcommerceToggled ? "not-allowed" : "pointer",
                      borderRadius: "8px",
                      opacity: isEcommerceToggled ? 0.5 : 1,
                    }}
                  >
                    <img
                      src={logo}
                      alt={item.label}
                      className="theme-image mb-2"
                      style={{ width: "250px", height: "150px" }}
                    />
                    <div style={{ fontSize: "14px", color: "#333" }}>
                      {item.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="row mb-2 mt-2">
              <label className="col-sm-3 col-form-label">Title</label>
              <div className="col-sm-9">
                <input
                  type="text"
                  className="form-control"
                  {...register("title")}
                  placeholder="Title"
                />
              </div>
            </div>
            <div className="row mb-2">
              <label className="col-sm-3 col-form-label">Sub Title</label>
              <div className="col-sm-9">
                <input
                  type="text"
                  className="form-control"
                  {...register("subTitle")}
                  placeholder="Sub Title"
                />
              </div>
            </div>
            <div className="row mb-2">
              <label className="col-sm-3 col-form-label">Description</label>
              <div className="col-sm-9">
                <textarea
                  className="form-control"
                  {...register("description")}
                  placeholder="Description"
                  rows={3}
                ></textarea>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <label className=" col-form-label">Button Text</label>
                {/* <div className="col-sm-6"> */}
                <input
                  type="text"
                  className="form-control"
                  {...register("ctaButton")}
                  placeholder="Button Text"
                />
                {/* </div> */}
              </div>
              <div className="col-sm-4">
                <label className="col-form-label">Button Link</label>
                <input
                  type="text"
                  className="form-control"
                  {...register("ctaButtonLink")}
                  placeholder="Button Link"
                />
              </div>
              <div className="col-sm-4">
                <label className="col-form-label">Banner Status</label>
                <div className="input-group">
                  <select className="form-select" {...register("isBanner")}>
                    <option value="enable"> Enable</option>
                    <option value="disable"> Disable</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end mt-4">
              <button
                type="submit"
                className="btn btn-dark d-flex justify-content-center align-items-center gap-2"
                disabled={isSubmitting}
              >
                <IoSave size={16} className="me-1" />
                <span>{isSubmitting ? "Saving..." : "Save"}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default BannerSettings;
